exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ai-text-settings-cell {\n  word-wrap: break-word;\n  word-break: break-word;\n  white-space: normal;\n  max-width: 100%;\n  overflow: hidden;\n  line-height: 1.4;\n}\n", ""]);
